import { createFileRoute } from "@tanstack/react-router";
import { VortexAuthSignInPage } from "@vortexnyc/vortex-core/auth/react";
import { z } from "zod";

import { signInClassNames } from "../integrations/vortex-auth/class-names";
import { authClient } from "../integrations/vortex-auth/client";
import {
  authRoutePaths,
  useAppAuth,
} from "../integrations/vortex-auth/runtime";

// Preserve type-safe redirect handling from the previous auth-backed route.
const signInSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/sign-in")({
  validateSearch: signInSearchSchema,
  component: SignInPage,
});

function SignInPage() {
  const { redirect } = Route.useSearch();
  // Post sign-in goes to the org selector unless an explicit redirect was set.
  const forceRedirectUrl = redirect ?? "/select-organization";
  const auth = useAppAuth();

  return (
    <VortexAuthSignInPage
      auth={auth}
      authClient={authClient}
      classNames={signInClassNames}
      description="Access the plasma portal with the shared workspace authentication flow."
      forceRedirectUrl={forceRedirectUrl}
      signUpUrl={authRoutePaths.signUpPath}
      title="Sign in"
    />
  );
}
